module.exports = "/images/apple_app_store.png?f38fd2fdaf0d44e7d4922717f5a4bdce";